import Table from "../../../../components/Table.jsx";
import Button from "../../../../components/Button.jsx";
import Checkbox from "../../../../components/Checkbox.jsx";
import styles from "../css/reverseStock.module.css";

export default function DetailsTableWithControls({ columns, data, selectAll, onToggleSelectAll, onReturn }) {
  const anyChecked = Array.isArray(data) && data.some((r) => !!r?.checked);
  return (
    <div className={styles.tableContainer}>
      <div className={styles.returnTopRight}>
        <Button variant="primary" onClick={onReturn} disabled={!anyChecked}>Return To Stock</Button>
      </div>
      <div className={styles.selectAllInline}>
        <Checkbox id="select-all" label="Select All" checked={selectAll} onChange={onToggleSelectAll} />
      </div>
      <Table columns={columns} data={data} />
    </div>
  );
}
